import { FormattedMessage, useIntl } from "react-intl";

import { SubmitButton } from "@/common/components/buttons/submit-button/SubmitButton";
import { FormShell } from "@/common/components/forms/FormShell";
import { PasswordField } from "@/common/components/forms/specific/password-field/PasswordField";

import {
  NEW_PASSWORD_INITIAL_VALUES,
  newPasswordSchema,
  type NewPasswordFormValues,
} from "./newPassword.schema";
import { Guide, Heading } from "./reset.styles";

type Props = {
  pending: boolean;
  onNewPassword: (password: string) => void;
};

const NewPasswordForm = ({
  onNewPassword,
  pending,
}: Props): React.ReactElement => {
  const { formatMessage } = useIntl();

  const handleSubmit = (values: NewPasswordFormValues) => {
    onNewPassword(values.password);
  };

  return (
    <FormShell<NewPasswordFormValues>
      initialValues={NEW_PASSWORD_INITIAL_VALUES}
      onSubmit={handleSubmit}
      validationSchema={newPasswordSchema}
      footer={
        <SubmitButton data-testid="reset-password-submit" pending={pending}>
          <FormattedMessage id="reset.password.button" />
        </SubmitButton>
      }
    >
      <Heading>
        <FormattedMessage id="reset.password.header" />
      </Heading>
      <Guide>
        <FormattedMessage id="reset.password.guide" />
      </Guide>
      <PasswordField
        autoComplete="new-password"
        fullWidth
        label={<FormattedMessage id="reset.password.label" />}
        name="password"
        placeholder={formatMessage({ id: "reset.password.hint" })}
      />
    </FormShell>
  );
};

export { NewPasswordForm };
